// @flow

import React, { type Node } from 'react';
import Helmet from 'react-helmet';

import faviconSrc from '@tectonics/favicon.svg';
import { getName } from '@tectonics/prs/merchant';
import { getMerchant } from '@tectonics/prs/incoming-payment';
import { type LookAndFeelRootProps } from '@tectonics/look-and-feel';

import { GlobalStyle } from './commons/global-style';
import { LoadingPayment } from './pages/loading-payment';
import { OpenedPaymentPage } from './pages/opened-payment';
import { PendingPaymentPage } from './pages/pending-payment';
import { CanceledPaymentPage } from './pages/canceled-payment';
import { ConfirmedPaymentPage } from './pages/confirmed-payment';

export default function Uber(props: LookAndFeelRootProps): Node {
  const merchant = getMerchant(props.incomingPayment);

  return (
    <>
      <Helmet
        title={`Página de pagamento${merchant && ` - ${getName(merchant)}`}`}
        link={[
          { rel: 'icon', href: faviconSrc },
          { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css?family=Open+Sans:400,600,700&display=swap' },
        ]}
      />
      <GlobalStyle />
      <Router { ...props }/>
    </>
  );
}

function Router(props: LookAndFeelRootProps): Node {
  switch (props.stage) {
    case 'loading':
      return <LoadingPayment />;

    case 'payment-opened':
      return <OpenedPaymentPage {...props} />;

    case 'payment-pending':
      return <PendingPaymentPage {...props} />;

    case 'payment-canceled':
      return <CanceledPaymentPage {...props} />;

    case 'payment-confirmed':
      return <ConfirmedPaymentPage {...props} />;

    default:
      throw new Error(`Unknown controller stage "${props.stage}"`);
  }
}
